import gql from 'graphql-tag';

export const updateEquipmentSettingsOnChannel = gql(/* GraphQL */ `
  mutation updateEquipmentSettingsOnChannel(
    $settings: ChannelEquipmentSettingsInput!
  ) {
    updateEquipmentSettingsOnChannel(settings: $settings) {
      id
      channel {
        _id
      }
      categories
      locations
    }
  }
`);
